import { AnchorHotInter } from '@/service/game/entity/anchorHot'
import { Base, Component, Prop } from '@/vue-property-decorator'
import { CardListOneProps } from '@/views/game/components/gameCardSuit2/cardList/listOne'
import { GameItemInter } from '@/service/game/entity/gameItem'
import {
  GameLayoutList,
  VerticalBottomName
} from '@/views/game/components/gameCardSuit2'
import { HomeLayoutType } from '@/api/common/type'
import { _ListLayoutHome as ListLayoutHome } from './listLayoutHome'
import { _ListLayoutSearch as ListLayoutSearch } from './listLayoutSearch'
import { _ListLayoutSubGame as ListLayoutSubGame } from './listLayoutSubGame'
import { PlatformCategoriesItemInter } from '@/service/game/entity/gameCategorie'
// import { createGetBoxCutRadius } from '@/views/game/utils/createGetBoxCutRadius'
import { gameHelper } from '@/views/game/services'
import { useMainStore } from '@/store/index'
import AppTypes from '@/vue-types'
interface Props {
  /** 列表数据 */
  listData:
    | Array<GameItemInter | AnchorHotInter>
    | Array<PlatformCategoriesItemInter>
  /** 布局数据 */
  listLayout: 'home' | 'subGame' | 'seach' | 'embedded'
  /** 不是热门、收藏、最近下面的卡片 */
  notHotRecentlyCollection?: boolean
}

@Component<GameListVertical>({
  name: 'GameListVertical'
})
export default class GameListVertical extends Base<unknown, Props> {
  @Prop(AppTypes.array.def([]))
  private listData!: Props['listData']
  @Prop()
  private listLayout!: Props['listLayout']
  @Prop(AppTypes.bool.def(false))
  private notHotRecentlyCollection!: Props['notHotRecentlyCollection']

  private get localListLayout() {
    const mapper: Record<
      Props['listLayout'],
      new (...params: unknown[]) => CardListOneProps
    > = {
      home: ListLayoutHome,
      subGame: ListLayoutSubGame,
      seach: ListLayoutSearch,
      embedded: ListLayoutSearch
    }
    return new mapper[this.listLayout](gameHelper.isSpecialPlatformGameCatgory)
  }

  /** 动态的css样式组件 */
  private get cssSizeType() {
    const topLayout =
      useMainStore().homeLayoutInfos?.topLayout ?? HomeLayoutType.style0
    // 在首页的时候,根据布局不同,会区分默认和小号
    if (this.listLayout === 'home' && topLayout === HomeLayoutType.style0) {
      return VerticalBottomName.CssSizeType.Small
    }
    if (this.listLayout === 'subGame') {
      if (gameHelper.isSpecialPlatformGameCatgory) {
        return VerticalBottomName.CssSizeType.Default
      } else {
        return VerticalBottomName.CssSizeType.Small
      }
    }

    return VerticalBottomName.CssSizeType.Default
  }

  // /** 获得卡片圆角的弧度 */
  // private get getBoxCutRadius() {
  //   const { isWeb } = useMainStore()
  //   return createGetBoxCutRadius(isWeb, createGetBoxCutRadius.mapperVertical)
  // }

  render() {
    return (
      <GameLayoutList props={this.localListLayout}>
        {this.listData.map((item) => {
          const props = VerticalBottomName.getProps(item)
          // 此处,特殊的圆角样式,后面再单独特殊的通过css样式处理
          // const radius = this.getBoxCutRadius(props.status)
          return (
            <VerticalBottomName
              cssSizeType={this.cssSizeType}
              cssVarManager={{ cssType: 'small' }}
              key={item.webId}
              // cssVarManagerMust={{
              //   boxCut: { '--box-cut-border-radius': radius }
              // }}
              props={props}
            />
          )
        })}
      </GameLayoutList>
    )
  }
}
